module.exports = __webpack_public_path__ + "img/nav-design-modern@2x.da06862.webp";